import authReducer from "./auth.slice";
import settingsReducer from "./settings.slice";
import ticketsReducer from "./tickets.slice";
import uploadReducer from "./upload.slice";
import filesReducer from "./files.slice";
import annoucementsReducer from "./annoucements.slice";

let reducers;
export default reducers = {
  auth: authReducer,
  upload: uploadReducer,
  settings: settingsReducer,
  tickets: ticketsReducer,
  files: filesReducer,
  annoucements: annoucementsReducer,
};
